'use client';

import { memo } from 'react';
import { ProductBigPreview } from './productBigPreview';

export const ProductBigPreviewMemo = memo(ProductBigPreview);
